export class ListInventorySubnetsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventorySubnetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
